import { Box, HStack, ModalProps, useMediaQuery, Text } from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/modal'
import { Card } from 'components/card/card'
import { boxShadow } from 'theme/common-style'
import { useEffect, useState } from 'react'
import { OrderIntakeFormEdit } from 'features/ticket-page/order-intake-form-edit'
import Status, { STATUS_CODE } from 'features/common/status'

type Props = Pick<ModalProps, 'isOpen' | 'onClose'> & {
  selectedTicketId: number | null
  ticketDetails?: any
}

const TicketDetailsModal: React.FC<Props> = ({ isOpen, onClose, selectedTicketId, ticketDetails }) => {
  const isTicketInvoiced = (ticketDetails?.projectStatusId) === (STATUS_CODE.INVOICED);
  const [isMobile] = useMediaQuery('(max-width: 480px)')
  const [modalSize, setModalSize] = useState<string>('5xl')

  useEffect(() => {
    if (isMobile) {
      setModalSize('sm')
    } else {
      setModalSize('5xl')
    }
  }, [isMobile])
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={modalSize} variant="custom">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader data-testid="update-ticket">
          <HStack>
            <Text fontSize="18px" fontWeight="500" ml="10px" mb="10px" mr="10px">
              Ticket: {ticketDetails?.woNumber}
            </Text>
            <Box pos="relative" top="-5px">
              <Status value={ticketDetails?.projectStatus as any} id={ticketDetails?.projectStatus as any} />
            </Box>
          </HStack>
        </ModalHeader>
        <ModalCloseButton _hover={{ bg: 'blue.50' }} />
        <ModalBody bg="bgGlobal.50" p={2} h="100%">
          <Card minH="600px" style={boxShadow} h="100%">
            <OrderIntakeFormEdit projectId={selectedTicketId} isReceivable={true} onCloseModal={onClose} isTicketInvoiced={isTicketInvoiced} />
          </Card>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default TicketDetailsModal
